import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const recomendados = [
  {
    title: "Arcane",
    classImg: "header arc",
  },
  {
    title: "Game of Thrones",
    classImg: "header got",
  },
  {
    title: "Harry Potter",
    classImg: "header hp",
  },
  {
    title: "Shingeki no Kyojin",
    classImg: "header snk",
  },
];

const Header = () => {
  return (
    <Carousel
      className="carousel"
      additionalTransfrom={0}
      arrows={false}
      autoPlay={true}
      autoPlaySpeed={6000}
      containerClass=""
      dotListClass=""
      draggable={false}
      focusOnSelect={false}
      infinite
      itemClass="margin-1px"
      keyBoardControl
      minimumTouchDrag={80}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 1024,
          },
          items: 1,
        },
        mobile: {
          breakpoint: {
            max: 464,
            min: 0,
          },
          items: 1,
        },
        tablet: {
          breakpoint: {
            max: 1024,
            min: 464,
          },
          items: 1,
        },
      }}
      showDots={false}
      sliderClass=""
      // slidesToSlide={1}
      swipeable={false}
      centerMode={false}
    >
      {recomendados.map((recomendado) => {
        return (
          <div className={recomendado.classImg} key={recomendado.id}>
            <div className="header-content-container">
              <div className="header-content p-4 pe-5 ps-3">
                <h1 className="mb-2 text-start fw-bolder">
                  {recomendado.title}
                </h1>
                <h5 className="fs-6 fw-lighter text-start">
                  Enjoy our recommendations!
                </h5>
              </div>
            </div>
          </div>
        );
      })}
    </Carousel>
  );
};

export default Header;
